<template>
    <div ref="root" class="module__map-iframe-wrapper">
        <div
            class="contact__map-optin bg-color-input"
            v-bind:data-source="getLink"
            v-bind:data-class="'module__map-iframe'"
            v-bind:data-width="650"
            v-bind:data-height="650"
        >
            <div
                v-bind:style="
                    'background-image: url(\'' +
                        generateMediaUrl({ path: 'media/images/contact/map_placeholder.jpg' }) +
                        '\')'
                "
                class="contact__map-optin-bg"
            ></div>
            <p class="contact__map-optin-text color-input">
                <span class="contact__map-optin-toggler-wrap">
                    <input
                        type="checkbox"
                        id="contact__map-optin-toggler"
                        class="contact__map-optin-toggler"
                        name="contact__map-optin-toggler"
                    />
                    <label
                        class="contact__map-optin-toggler-label"
                        for="contact__map-optin-toggler"
                        v-html="$helpers.uiText('F001')"
                    ></label>
                </span>
            </p>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Map from '@/external/assorted/Map';

export default {
    data() {
        return {};
    },
    components: {},
    methods: {},
    computed: {
        ...mapGetters(['getProp', 'editorMode', 'generateMediaUrl']),
        getLink() {
            let link = '';
            link += 'https://www.google.com/maps?q=';
            link += this.getProp('deha.user.strasse');
            link += ', ';
            link += this.getProp('deha.user.plz');
            link += ' ';
            link += this.getProp('deha.user.ort');
            link += '&z=9&output=embed';
            return link;
        }
    },
    created() {},
    mounted() {
        if (this.editorMode) {
            let i = new Map();
            i.init(this.$refs.root);
        }
    },
    props: {}
};
</script>
